/**
 * Delivery Status Lazy Loading
 * Loads delivery status snippets only when product cards enter viewport
 * Uses Intersection Observer API for performance
 */

(function() {
  'use strict';

  // Check if Intersection Observer is supported
  if (!window.IntersectionObserver) {
    // Fallback: load all immediately if no support
    loadAllDeliveryStatuses();
    return;
  }

  // No cache needed - content is already in HTML
  
  // Configuration
  const CONFIG = {
    rootMargin: '50px', // Start loading 50px before card enters viewport
    threshold: 0.01
  };

  /**
   * Show delivery status for a single card (content is already in HTML, just hidden)
   */
  function loadDeliveryStatus(element) {
    // Check if already loaded
    if (element.classList.contains('bpo-delivery-status-loaded')) {
      return;
    }

    element.style.visibility = 'visible';
    element.classList.add('bpo-delivery-status-loaded');
  }

  /**
   * Fallback: Show all delivery statuses immediately (for browsers without Intersection Observer)
   */
  function loadAllDeliveryStatuses() {
    const elements = document.querySelectorAll('[data-lazy-delivery-status]:not(.bpo-delivery-status-loaded)');
    elements.forEach(function(element) {
      loadDeliveryStatus(element);
    });
  }

  /**
   * Initialize lazy loading with Intersection Observer
   */
  function initLazyLoading() {
    const elements = document.querySelectorAll('[data-lazy-delivery-status]:not(.bpo-delivery-status-loaded)');
    
    if (elements.length === 0) {
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const element = entry.target;
          observer.unobserve(element);
          loadDeliveryStatus(element);
        }
      });
    }, CONFIG);

    // Observe all delivery status placeholders
    elements.forEach(function(element) {
      observer.observe(element);
    });
  }

  /**
   * Re-initialize after dynamic content loads (e.g., infinite scroll, filters)
   */
  function reinitLazyLoading() {
    // Small delay to ensure DOM is ready
    setTimeout(initLazyLoading, 100);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyLoading);
  } else {
    initLazyLoading();
  }

  // Re-initialize after AJAX content loads (for filtered collections, etc.)
  document.addEventListener('shopify:section:load', reinitLazyLoading);
  document.addEventListener('shopify:section:reorder', reinitLazyLoading);
  
  // Also listen for custom events that might indicate new content
  window.addEventListener('collection:filtered', reinitLazyLoading);
  window.addEventListener('collection:paginated', reinitLazyLoading);

  // Export for manual re-initialization if needed
  window.deliveryStatusLazy = {
    init: initLazyLoading,
    reinit: reinitLazyLoading
  };
})();
